import axios from 'axios';
import store from '../store/index';
import {ls} from "../store/local-store";

let baseUrl = '';
if (process.env.VUE_APP_BASE_URL) {
	baseUrl = process.env.VUE_APP_BASE_URL;
}

let http = axios.create({
	baseURL: baseUrl,
	timeout: 1000 * 12
});

http.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

// 请求拦截
http.interceptors.request.use(onRequestFulfilled, onRequestRejected);

// 响应拦截
http.interceptors.response.use(onResponseFulfilled, onResponseRejected);

function onRequestFulfilled(config) {
	let {cityId} = store.state.app || {};
	let userStore = store.state.user || {};
	let {sessionId, user} = userStore || {};
	let {id: userId} = user || {};
	sessionId = sessionId || ls.getItem('sessionId');
	let defaultParams = {
		cityId,
		userId,
		sessionId
	};
	config.data = Object.assign(defaultParams, config.data);
  // 本地环境传nocookie，不进行cookie验证
  if (process.env.VUE_APP_ENV === 'serve') {
    config.params = Object.assign({
      nocookie: 'f5a5e87c681f4d4aab7e36e45acb4d4e'
    }, config.params)
  }
	try {
		const packageVersion = require('../../package.json').version;
		config.params = config.params ? Object.assign(config.params, {dbv: packageVersion}) : {dbv: packageVersion};
	} catch (e) {
		console.error(e);
	}
	return config;
}

function onRequestRejected(error) {
	return Promise.error(error);
}

function onResponseFulfilled(res) {
	let {data, status} = res;
  if (typeof data === 'string') {
    const {jsonr: {
      data: _data,
      errmsg: msg,
      status: _status
    }} = parseResponseData(data);
    if (status === 200) {
      if (_status === '00') {
        return Promise.resolve(_data);
      }
    }
    return Promise.reject({
      code: _status,
      msg,
      response: res
    });
  } else {
    const {data:_data, status: _status} = data || {}
    if (_status === 'OK') {
      return Promise.resolve(_data)
    } else {
      return Promise.reject({
        code: _status
      })
    }
  }
}

function onResponseRejected(error) {
	const {response} = error;
	if (response) {
		// 请求已发出，但是不再2xx的范围
		return Promise.reject({
			code: response.status,
			msg: '请求错误',
			response
		});
	} else {
		console.log('error断网！！！！！！！！！！！！！！！！！！', error);
		if (!window.navigator.onLine) {
			// 断网
			return Promise.reject({
				code: '601',
				msg: '断网了',
				response
			});
		} else {
			return Promise.reject({
				code: '616',
				msg: '网络异常，请重试~',
				response
			});
		}
	}
}

function parseResponseData(data) {
	if (data) {
		return JSON.parse(data.replace(/^\*\*YGKJ/, '').replace(/YGKJ##$/, '') || '{}');
	}
	return {};
}

export default http;
